import { mount } from 'ripple';
import { App } from './App.ripple';

// Mount the app
mount(App, { target: document.getElementById('app')! });